<template>
  <footer class="footer">
    <section class="footer__content container">
      <div class="footer__mhhc">
        <a href="https://www.mhhcco.com/" class="logo" target="_blank">
          <img src="../assets/mhhc_logo_bottom.png" alt="MHHC Enterprises logo">
        </a>
        <div class="footer__mhhc-about">
          <span>About</span>
          <div class="links">
            <a href="https://www.mhhcco.com/" target="_blank">
              Internal page
            </a>
            <a href="https://www.mhhcco.com/corporate-services" target="_blank">
              Services page
            </a>
            <a href="https://www.mhhcco.com/contact" target="_blank">
              Contact
            </a>
            <a href="https://microcaps.com/privacy-policy/" target="_blank">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/footer.scss';
</style>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    };
  },
};
</script>